import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import queryKeys from '@pray/shared/queryKeys';
import studioService from '@pray/shared/services/studioService';
import type { CreditAccount } from '@pray/shared/services/studioService/credits';
import { mapCreditAccount } from '@pray/shared/services/studioService/credits';

type UseCreditAccountProps = {
  artistId: string;
  refetchInterval?: number | false;
};

export function useCreditAccount({
  artistId,
  refetchInterval = false,
}: UseCreditAccountProps): UseQueryResult<CreditAccount> {
  async function fetchCreditAccount() {
    const response = await studioService.credits.getCreditAccount({
      artistId,
    });

    return mapCreditAccount(response.data);
  }

  const query = useQuery({
    enabled: !!artistId,
    queryKey: queryKeys.artistCreditAccount(artistId),
    queryFn: fetchCreditAccount,
    refetchInterval,
  });

  return query;
}
